<template>
  <div>
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h2 class="card-title">LED Lightbox</h2>
              <p class="category">*Everything I make glows....remember that*</p>
            </div>
            <div class="card-content">
              <img src="../../../../../static/img/LightBox/1.jpg" alt="A group of 4 snowflakes illuminated" style="border-radius:30px;margin-bottom:20px">
              <p>This LED Lightbox was originally a little birthday gift I made for a friend, but turned into a little more...so I ended up building a number of them for various occasions.</p>
            </div>
          </div>
        </div>
  </div>
  <!-- YouTube Demos -->
  <div class="row">
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">LED Lightbox Demo</h4>
            </div>
            <div class="card-content">
              <youtube :video-id="videoIdOne" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">LED Lightbox Demo 2</h4>
            </div>
            <div class="card-content">
              <youtube :video-id="videoIdTwo" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
  </div>

  <!-- Demo Stuff -->
  <div class="row">
      <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Built With</h4>
            </div>
            <div class="card-content">
              <ul style="font-size:15px">
                <li>[Arduino Nano] - The microcontroller used</li>
                <li>[WS2812B RGB 5050 LED Strip] – LEDs inside the box</li>
                <li>[1/8" Cast Acrylic]</li>
                <li>[SPDT (Single Pole, Double Throw) Switch]</li>
                <li>[Momentary Push Button]</li>
                <li>[USB Micro Cable]</li>
                <li>[USB Wall Charger]</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">CAD Model</h4>
            </div>
            <div class="card-content">
              <p>The necessary STL files are provided <a href="https://github.com/mclemcrew/led-light-sculpture" target="_blank">here</a> so you can print your own lightbox! Feel free to modify it how you see fit! :D</p>
            </div>
            <div class="card-header">
              <h4 class="card-title">AI Files</h4>
            </div>
            <div class="card-content">
             <p>
               I have provided a template for the circular design that I wanted. You will need this for cutting the arcylic with a laser cutter or CNC machine.  You can grab that file <a href="https://github.com/mclemcrew/led-light-sculpture" target="_blank">here</a>.
             </p>
            </div>
          </div>
        </div>
    </div>

    <!-- Demo Stuff -->
  <div class="row">
      <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Circuit Diagram</h4>
            </div>
            <div class="card-content">
              <p>If you want to run the lightbox off a 9V battery, the circuit diagram is pictured below.</p>
              <img src="../../../../../static/img/LightBox/demo-1.png" alt="A group of 4 snowflakes illuminated" style="margin-bottom:20px">
              <p>If you want to run the lightbox off AC wall power (what the materials listed above are for) then the circuit diagram changes just a bit. Take the USB micro cable and solder the power (red) wire to the SPDT switch instead of the one coming from the 9V battery. The ground wire from the micro USB should remain connected to the Arduino Nano. The green and white wires in the USB cord can be cut away...they aren't going to be used here. You can use the Vin port of the Nano or just plug the other end of the USB micro cable into the USB port and connect the cables accordingly.</p>
            </div>
          </div>
        </div>
    </div>

    <!-- Gallery -->
    <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Gallery</h4>
            </div>
            <div class="card-content" style="display: flex;
                  flex-flow: row wrap;
                  justify-content: center;">
              <!-- Image Gallery -->
              <gallery :images="images" :index="index" @close="index = null"></gallery>
              <div
                class="image"
                v-for="(image, imageIndex) in images"
                :key="imageIndex"
                @click="index = imageIndex"
                :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
              ></div>
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  data () {
    return {
      videoIdOne: '20pzKRrDehA',
      videoIdTwo: 'gu9hagKKioA',
      images: [
        '../../../../../static/img/LightBox/1.jpg',
        '../../../../../static/img/LightBox/2.jpg',
        '../../../../../static/img/LightBox/3.jpg',
        '../../../../../static/img/LightBox/4.jpg',
        '../../../../../static/img/LightBox/5.jpg',
        '../../../../../static/img/LightBox/6.jpg',
        '../../../../../static/img/LightBox/7.jpg',
        '../../../../../static/img/LightBox/8.jpg'
      ],
      index: null
    }
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    },
    playing () {
      console.log('/\\o/ we are watching!!!')
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  components: {
    'gallery': VueGallery
  }
}
</script>
<style>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
.image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Projects/LEDBox.vue